import { forwardRef, type SVGProps } from 'react';

export interface CautionOutlineIconProps extends Omit<SVGProps<SVGSVGElement>, 'css'> {}

export const CautionOutlineIcon = forwardRef<SVGSVGElement, CautionOutlineIconProps>((props, ref) => (
  <svg ref={ref} {...props} aria-hidden="true" fill="none" viewBox="0 0 32 32">
    <path
      d="M16.058 20.884C16.923 20.884 17.615 21.577 17.616 22.442 17.616 23.307 16.923 24 16.058 24.001 15.193 24.001 14.5 23.307 14.5 22.442 14.501 21.577 15.193 20.884 16.058 20.884ZM16.058 9C16.865 9.001 17.499 9.693 17.442 10.558L16.981 18.461C16.923 18.98 16.577 19.384 16.058 19.384 15.539 19.384 15.192 19.038 15.134 18.461L14.673 10.558C14.673 9.693 15.308 9 16.058 9Z"
      fill="currentColor"
    />
    <path
      clipRule="evenodd"
      d="M12.5569 4.92624C14.1166 2.35914 17.8839 2.35914 19.4436 4.92624L30.4221 22.9946C31.9771 25.5549 30.2166 28.7905 27.2678 28.9907L26.9788 29.0005H5.02176L4.73269 28.9907C1.87885 28.7971 0.138506 25.7608 1.43875 23.2446L1.5784 22.9946L12.5569 4.92624ZM17.5208 6.09421C16.8374 4.96937 15.1632 4.96937 14.4798 6.09421L3.50125 24.1626C2.83252 25.2636 3.60511 26.7502 5.02176 26.7505H26.9788C28.3951 26.75 29.1677 25.2635 28.4993 24.1626L17.5208 6.09421Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
));

CautionOutlineIcon.displayName = 'CautionOutlineIcon';
